import React from 'react';
export const Link = ({
  linkComponent,
  ...props
}) => {
  // Hack?
  const Component = linkComponent || 'a';
  return /*#__PURE__*/React.createElement(Component, props);
};